class Header {
  constructor() {
    this.init = this.init.bind(this);
    this.determineScrollRatio = this.determineScrollRatio.bind(this);
    this.init();
  }

  init() {
    const header = document.querySelector('[data-header]');
    const headerMenuTrigger = document.querySelector('[data-header-menu-trigger]');

    if (header && headerMenuTrigger) {
      headerMenuTrigger.addEventListener('click', () => {
        header.classList.toggle('header--menu-visible');
        document.body.classList.toggle('main-menu-visible');
      });

      window.addEventListener('scroll', () => {
        // smaller header when the website is scrolled more than 70% of the viewport height
        if (this.determineScrollRatio() > 0.7) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      });
    }
  }

  determineScrollRatio() {
    return window.scrollY / window.innerHeight;
  }
}

export default new Header();
